module.exports = __webpack_public_path__ + "static/media/republican.1e61aa7f.svg";